export default "__VITE_ASSET__DmU1euG1__"